var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VcSelectField',{attrs:{"items":_vm.staff,"pre-selection":_vm.initialSelection},on:{"selection-changed":_vm.onSelectionChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }